<div class="welcome-step">
    <div class="welcome-illustration" aria-hidden="true">
        <img src="assets/illustrations/onboarding.svg" alt="" class="welcome-svg">
    </div>

    <div class="welcome-copy">
        <div class="welldone-header">
            <img src="assets/logo-icon.svg" alt="Welldone Logo" class="welldone-logo">
            <h2 class="welldone-title">WELL DONE</h2>
        </div>

        <h1 class="welcome-heading">
            Benvenuto nell'area di
            <span class="gradient-text">onboarding</span>
        </h1>

        <p class="welcome-subtitle">
            Iniziamo la compilazione della richiesta.<br>
            Ti guidiamo passo dopo passo fino all'attivazione.
        </p>

        <ul class="welcome-highlights">
            <li>
                <i class="bi bi-person-badge"></i>
                Dati rappresentante
            </li>
            <li>
                <i class="bi bi-building"></i>
                Informazioni società
            </li>
            <li>
                <i class="bi bi-credit-card"></i>
                Attivazione piano
            </li>
        </ul>

        <button class="btn-procedi" (click)="nextStep()" [disabled]="isProcessing">
            <span *ngIf="isProcessing" class="spinner-border spinner-border-sm me-2" role="status"></span>
            {{ isProcessing ? 'Caricamento...' : 'Procedi' }}
        </button>
    </div>
</div>
